var map = {
	"./amex.svg": "b348",
	"./diners.svg": "b20c",
	"./discover.svg": "45ab",
	"./jcb.svg": "7a88",
	"./mastercard.svg": "18c6",
	"./unionpay.svg": "35ce",
	"./visa.svg": "8976"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f134";